import { useState, useEffect, useCallback } from 'react';

export function useSwingHistory() {
  const [swingHistory, setSwingHistory] = useState([]);
  const [showComparison, setShowComparison] = useState(false);
  const [showStats, setShowStats] = useState(false);
  const [selectedSwings, setSelectedSwings] = useState([]);

  // Load swing history from localStorage on mount
  useEffect(() => {
    const savedHistory = localStorage.getItem('swingslot_history');
    if (savedHistory) {
      try {
        const history = JSON.parse(savedHistory);
        // Validate it's an array
        if (Array.isArray(history)) {
          setSwingHistory(history);
          console.log('Loaded swing history:', history.length, 'previous analyses');
        } else {
          throw new Error('History is not an array');
        }
      } catch (e) {
        console.error('Failed to load history, clearing corrupted data:', e);
        // Clear corrupted data to prevent future issues
        localStorage.removeItem('swingslot_history');
        // History is already empty from useState default
      }
    }

    // Set version flag
    localStorage.setItem('swingslot_version', 'v3.0-db-sync');
  }, []);

  // Save swing to history
  const saveSwingToHistory = useCallback((analysis, videoFileName, club) => {
    const overallScore = analysis.swingScore?.overall || analysis.swingScore || 0;
    const swingEntry = {
      id: Date.now(),
      date: new Date().toISOString(),
      fileName: videoFileName,
      club: club,
      swingScore: overallScore,
      swingGrade: analysis.swingGrade || null,
      projectedHandicap: analysis.projectedHandicap?.range || null,
      topIssue: analysis.whatsCostingStrokes?.[0]?.issue || analysis.improvements?.[0]?.title || 'N/A',
    };

    setSwingHistory(prev => {
      const updatedHistory = [swingEntry, ...prev].slice(0, 10); // Keep last 10
      localStorage.setItem('swingslot_history', JSON.stringify(updatedHistory));
      console.log('Saved swing to history. Total swings:', updatedHistory.length);
      return updatedHistory;
    });
  }, []);

  return {
    swingHistory,
    setSwingHistory,
    showComparison,
    setShowComparison,
    showStats,
    setShowStats,
    selectedSwings,
    setSelectedSwings,
    saveSwingToHistory,
  };
}
